import { render, staticRenderFns } from "./tradesperson-recommendation.vue?vue&type=template&id=f50bd0ee&scoped=true"
import script from "./tradesperson-recommendation.vue?vue&type=script&lang=js"
export * from "./tradesperson-recommendation.vue?vue&type=script&lang=js"
import style0 from "./tradesperson-recommendation.vue?vue&type=style&index=0&id=f50bd0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50bd0ee",
  null
  
)

export default component.exports